import { isCellInRange, isCoordsEqual, normalizedRange } from "./cell_selection_utils";
import { CellCoord, CellRange, EditTrigger, RangeEdges } from "./interactive_table.types";

export const selectRangeEdges = (range: CellRange | null, coord: CellCoord): RangeEdges | null => {
  if (!range) {
    return null;
  }
  const nr = normalizedRange(range);
  if (!isCellInRange(coord, nr)) {
    return null;
  }
  return {
    top: coord.rowIndex === nr.minRow,
    bottom: coord.rowIndex === nr.maxRow,
    left: coord.colIndex === nr.minCol,
    right: coord.colIndex === nr.maxCol
  };
};

const selectIsRangeBottomRight = (range: CellRange | null, coord: CellCoord): boolean => {
  if (!range) {
    return false;
  }
  const nr = normalizedRange(range);
  return coord.rowIndex === nr.maxRow && coord.colIndex === nr.maxCol;
};

export const selectIsCellInFillArea = (
  selectionRange: CellRange | null,
  fillRange: CellRange | null,
  coord: CellCoord
): boolean => {
  if (!selectionRange || !fillRange) {
    return false;
  }
  return (
    isCellInRange(coord, normalizedRange(selectionRange)) || isCellInRange(coord, normalizedRange(fillRange))
  );
};

const isSingleCellSelection = (selectionRange: CellRange | null): boolean => {
  if (!selectionRange) {
    return false;
  }
  return isCoordsEqual(selectionRange.anchor, selectionRange.active);
};

export const selectShowFillHandle = (
  selectionRange: CellRange | null,
  fillRange: CellRange | null,
  isFillDragging: boolean,
  coord: CellCoord | null
): boolean => {
  if (!coord) {
    return false;
  }
  if (isFillDragging) {
    return selectIsRangeBottomRight(fillRange, coord);
  }
  return isSingleCellSelection(selectionRange) && selectIsRangeBottomRight(selectionRange, coord);
};

export const selectIsCellInEditMode = (editModeCoord: CellCoord | null, coord: CellCoord): boolean => {
  if (!editModeCoord) {
    return false;
  }
  return isCoordsEqual(editModeCoord, coord);
};

/**
 * Returns the EditTrigger for a given cell if it is currently in edit mode,
 * otherwise null.
 */
export const selectCellEditTrigger = (
  editModeCoord: CellCoord | null,
  editModeTrigger: EditTrigger | null,
  coord: CellCoord
): EditTrigger | null => {
  if (!editModeCoord || !isCoordsEqual(editModeCoord, coord)) {
    return null;
  }
  return editModeTrigger;
};
